import * as React from "react";

import ISystemState from "../models/interfaces/ISystemState";

const SystemContext = React.createContext({
    systemState: {} as ISystemState,
    dispatch: {} as any
});

export default SystemContext;